<template>
  <div class="overview">
    <div v-if="isAdmin" class="card card-container shadow-sm">
      <div class="card-body">
        <h5 class="card-title" data-test-id="agency-details-members-title">Members</h5>
        <div class="count" data-test-id="agency-details-members-count">{{ data.memberCount }}</div>
      </div>
    </div>
    <div v-if="isAdmin" class="card card-container shadow-sm">
      <div class="card-body">
        <h5 class="card-title" data-test-id="agency-details-trucks-title">Trucks</h5>
        <div class="count" data-test-id="agency-details-trucks-count">{{ data.trucksCount }}</div>
      </div>
    </div>
    <div class="card card-container shadow-sm">
      <div class="card-body">
        <h5 class="card-title" data-test-id="agency-details-cases-today-title">Cases</h5>
        <h6 class="card-subtitle mb-2 text-muted" data-test-id="agency-details-cases-today-subtitle">Today</h6>
        <div class="count" data-test-id="agency-details-cases-today-count">{{ data.casesCountToday }}</div>
      </div>
    </div>
    <div class="card card-container shadow-sm">
      <div class="card-body">
        <h5 class="card-title" data-test-id="agency-details-cases-last-month-title">Cases</h5>
        <h6 class="card-subtitle mb-2 text-muted" data-test-id="agency-details-cases-last-month-subtitle">
          {{ lastXdays }}
        </h6>
        <div class="count" data-test-id="agency-details-cases-last-month-count">{{ data.casesCount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    timespan: {
      type: String,
      default: "month"
    }
  },
  computed: {
    lastXdays() {
      if (this.isAdmin) {
        if (this.timespan === "month") {
          return "Last 30 days";
        } else {
          return "Last 7 days";
        }
      } else {
        return "Last 5 days";
      }
    }
  }
};
</script>

<style scoped>
.card-container {
  flex: 1 0 10rem;
  height: 8.5rem;
}
.count {
  bottom: 0.75rem;
  font-size: 2rem;
  font-style: italic;
  position: absolute;
}
.overview {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 1rem;
}
</style>
